/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card.card-cascade[_ngcontent-%COMP%]   .view.gradient-card-header[_ngcontent-%COMP%]{padding:1rem;text-align:center}.card.card-cascade[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .card.card-cascade[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-bottom:0}.blue-gradient[_ngcontent-%COMP%]{background:linear-gradient(40deg,#45cafc,#4285f4)}.font-bold[_ngcontent-%COMP%]{font-weight:600}.card.card-cascade[_ngcontent-%COMP%]   .view[_ngcontent-%COMP%]{box-shadow:0 3px 10px 0 rgba(0,0,0,.15),0 3px 12px 0 rgba(0,0,0,.15)}"];
export { styles as styles };
